import { Observable } from 'rxjs';

export abstract class ProductVerificationAdapter {
  abstract isApplianceOnRecallList(serialNumber: string, applianceCode: string): Observable<boolean>;
}
